import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Typography } from "@material-ui/core";
import DropMenu from "../../components/service/admin/dropMenu";

const styles = (theme) => ({
  boxAction: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
  },
  title: {
    marginRight: theme.spacing(2),
  },
  backFrame: {
    display: "flex",
    // color: "#546d7a",
    alignItems: "center",
    cursor: "pointer",
  },
});
class Service extends React.Component {
  render() {
    const { adminService, classes, ...props } = this.props;
    return (
      <div className={classes.boxAction}>
        <div
          className={classes.backFrame}
          onClick={() => this.props.history.push("/service-admin/list")}
        >
          <ArrowBackIosIcon />
          <Typography
            variant="h6"
            className={classes.title}
          >{`${adminService.name}`}</Typography>
        </div>
        <DropMenu {...props} />
      </div>
    );
  }
}

Service.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Service)));
